import React from "react";
import { Animated , View } from "react-native";
import CText from "./CText";
import { CreateResponsiveStyle, DEVICE_SIZES} from "rn-responsive-styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";


const CDatePicker = (props) => {
  const styles = useStyles();
  if (true) {
    return (
      <View style={styles.inputWrapper}>
        <CText.inputTopLabel>{props.label}
        {
            props.mandatoryField
            ? <Animated.Text
            style={[
              styles.inlineError,
              { color: "#f00", fontSize: 15, fontWeight: "500" },
            ]}
          >
            {" *"}
          </Animated.Text>
          : null
          }
        </CText.inputTopLabel>
        <View style = {styles.datePicker}>
            <DatePicker
            showIcon = {true}
            showYearDropdown    
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            selected={props.value}
            className={props.isMobile ? "datePicker-mobile":"datePicker"}
            shouldCloseOnSelect={true}
            onSelect={(date) => props.onDateChange(date)} 
            dateFormat={"dd/MM/yyyy"}
            id="dobChange"
            maxDate={new Date(moment().subtract(18, "year").format())}
            portalId="root-portal"
            disabled={ props.editable}
        />
        </View>
       
      </View>
    );
  } 
};
const useStyles = CreateResponsiveStyle(
  {
   
    datePicker: {
        backgroundColor: "#fff",
        borderRadius: 6,
        height: 35,
        padding: 5,
        width : 240
      },
      inlineError: {
        fontFamily: "Inter",
        fontSize: 12,
        color: "#db1a1a",
        marginTop: 3,
        marginLeft: 0,
      },
    
    inputWrapper: {
      gap: 1,
      marginTop:12
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
    
    },
  }
);

export default CDatePicker;
